<template>
  <div id="home">
    <HeaderComponent></HeaderComponent>
    <div class="text-center">
      <!-- <h1 class="mb-3">
        Le jeu Kawaa
      </h1> -->
      <h4 class="text-primary font-weight-bolder">
        Bienvenue sur le jeu Kawaa
      </h4>
      <p class="mb-2 font-weight-lighter game-description">
        Les règles du jeu sont trés simples et vous permetteront d'en savoir plus sur les autres joueurs, que vous vous connaissez un peu, beaucoup, ou pas du tout !
      </p>
      <div class="d-flex flex-column m-auto text-center font-weight-bold text-primary mb-3">
        <p class="h5 mb-2">A vos cartes... Prêts</p>
        <p class="h4">Partez !</p>
        <div class='onesignal-customlink-container'></div>
      </div>
      <!-- <div class="mx-auto">
        <b-button class="button-start" variant="dark">
          <router-link to="/card" class="text-white">
            Commencer
          </router-link>
        </b-button>
      </div> -->
    </div>
  </div>
</template>

<script>
  import HeaderComponent from '@/components/HeaderComponent'
  import firebase from 'firebase'

  export default {
    name: 'home',
    components: {
      HeaderComponent
    },
    computed: {
      getCurrentUser: function () {
        const user = firebase.auth().currentUser
        console.log(user)
      }
    },
    methods: {}
}
</script>

<style>
  .game-description {
    font-size: 14px;
    line-height: 21px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #999999;
    padding: 0 15px;
  }
</style>


// WEBPACK FOOTER //
// src/components/HomeComponent.vue